/* Fetch Shopify's newest-first collection view; retain a useful link on failure.
   Placeholder cards, rendered at roughly a real card's height, hold the shelf's space
   from first paint. Without JavaScript a <noscript> link replaces them; when the
   request fails, the hidden fallback link is revealed instead. */
if (!customElements.get('tandoori-new-arrivals')) {
  customElements.define('tandoori-new-arrivals', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.fallback = this.querySelector('[data-arrival-fallback]');
      this.grid = this.querySelector('[data-arrival-cards]');
      this.classList.add('is-loading');
      if (this.fallback) this.fallback.hidden = true;
      this.controller = new AbortController();
      this.load();
    }
    async load() {
      const controller = this.controller;
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(this.dataset.source, { signal: controller.signal });
        if (!response.ok) throw new Error('Collection unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...html.querySelectorAll('.tb-book')].slice(0, 4);
        if (!this.isConnected || controller.signal.aborted) return;
        if (!cards.length) throw new Error('No new arrivals');
        this.grid.replaceChildren(...cards);
        this.loaded = true;
      } catch (_) {
        // The newest-first collection link remains usable, even without JavaScript.
        if (!this.isConnected) return;
        this.grid.querySelectorAll('.tb-book--skeleton').forEach((placeholder) => placeholder.remove());
        if (this.fallback) this.fallback.hidden = false;
      } finally {
        clearTimeout(timer);
        this.classList.remove('is-loading');
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
